import React, { useState } from 'react';
import { Input } from 'design-react-kit';

const Textarea = ({
  name,
  label,
  value,
  required,
  infoText,
  disabled,
  invalid,
  onChange,
  max_length,
}) => {
  const [charCounter, setCharCounter] = useState(0);

  const custom_infotext = (
    <div className="d-flex justify-content-between">
      <div>{infoText}</div>
      {max_length > 0 && (
        <div className="char-counter">
          {charCounter}/{max_length}
        </div>
      )}
    </div>
  );
  return (
    <>
      <Input
        id={name}
        name={name}
        label={label}
        tag="textarea"
        rows={10}
        required={required}
        infoText={custom_infotext}
        disabled={disabled}
        readOnly={disabled}
        invalid={invalid}
        onChange={(e) => {
          const v = e.target.value;
          setCharCounter(v?.length ?? 0);
          onChange(name, v);
        }}
        value={value ?? undefined}
        maxLength={max_length ?? undefined}
      />
    </>
  );
};
export default Textarea;
